import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faComments } from '@fortawesome/free-solid-svg-icons';

const PromoHydroluz = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  const gradientTitle = {
    background: 'linear-gradient(90deg, #004aad, #00c6ff)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    display: 'inline-block',
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.3,
        duration: 0.6,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <Box
      ref={ref}
      sx={{
        px: { xs: 3, md: 6 },
        py: 10,
        textAlign: 'center',
        backgroundColor: '#fff',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <Button
          href="/categorias"
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faShoppingCart} />}
          sx={{
            bgcolor: '#00c6ff',
            color: '#0A2A5E',
            fontWeight: 'bold',
            borderRadius: '30px',
            px: 4,
            py: 1.5,
            fontSize: { xs: '0.8rem', sm: '1rem' },
            textTransform: 'none',
            mb: 6,
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              transform: 'translateY(-3px)',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
              bgcolor: '#33d4ff',
            },
          }}
        >
          Explora todos los productos
        </Button>
      </motion.div>

      <Typography
        variant="h2"
        sx={{
          fontWeight: 'bold',
          fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
          mb: 1,
        }}
      >
        <Box component="span" sx={gradientTitle}>HYDROLUZ</Box>
      </Typography>

      <Typography
        variant="h3"
        sx={{
          mt: 4,
          mx: 'auto',
          maxWidth: '700px',
          fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
          color: '#444',
          lineHeight: 1.8,
        }}
      >
        En <strong>HYDROLUZ</strong> encontrarás una tienda online con <strong>productos diversos para el hogar, tecnología, herramientas, accesorios y más</strong>. 
        Síguenos en redes sociales y no te pierdas ninguna novedad.
      </Typography>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 1 }}
        viewport={{ once: true }}
      >
        <Box mt={5}>
          <Button
            component="a"
            href="https://api.whatsapp.com/send?phone=593991911882&text=Hola%2C%20quiero%20más%20información%20sobre%20sus%20productos%20y%20beneficios%20en%20HYDROLUZ"
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<FontAwesomeIcon icon={faComments} />}
            sx={{
              bgcolor: '#ffcc00',
              color: '#0A2A5E',
              fontWeight: 'bold',
              fontSize: { xs: '0.8rem', sm: '1rem' },
              px: 5,
              py: 1.5,
              borderRadius: '50px',
              textTransform: 'none',
              transition: 'all 0.3s ease',
              '&:hover': {
                bgcolor: '#ffe066',
                transform: 'scale(1.05)',
                boxShadow: '0px 6px 18px rgba(255, 204, 0, 0.3)',
              },
            }}
          >
            Contáctanos por WhatsApp
          </Button>
        </Box>
      </motion.div>
    </Box>
  );
};

export default PromoHydroluz;
